import { cloneDeep, isEmpty } from 'lodash';

import api from '@/api';
import {api as apiV2} from '@/api/api.v2';
import { getItemByKeyRecursive, setItemByKeyRecursive } from '@/components/Lists/lib';

const settingsModel = {
    state: {
        loading: false,
        curveDataLoading: true,
        // metaColumnsLoading: false,
        error: false,
        columns: [],
        gisData: [],
        filteredGisData: [],
        curveData: {},
        activeCurveDataKeys: [],
        selectedGisDataRecordGlobal: {},
        curvesByCode: {},
        drawerLoading: true,
        curveFillColor: '#FEFB41',
        graph: {},
        tablets: null,
        preparingGisData: true,
        updateDataForTablets: false,
        gisCurveError: {},
        isGroup: false,
        groupName: '',
        selectedWells: [],
        openedGisItems: [],
    },
    reducers: {
        setUpdateDataForTablets(state, payload) {
            return { ...state, updateDataForTablets: payload };
        },
        setLoading(state, payload) {
            return { ...state, loading: payload };
        },
        setCurveDataLoading(state, payload) {
            return { ...state, curveDataLoading: payload };
        },
        // setMetaColumnsLoading(state, payload) {
        //     return { ...state, metaColumnsLoading: payload };
        // },
        setDrawerLoading(state, payload) {
            return { ...state, drawerLoading: payload };
        },
        setError(state, payload) {
            return { ...state, error: payload };
        },
        setColumns(state, payload) {
            return { ...state, columns: payload };
        },
        setGisData(state, payload) {
            return { ...state, gisData: payload };
        },
        setSelectedRecordGlobal(state, payload) {
            return { ...state, selectedGisDataRecordGlobal: payload };
        },
        setFilteredData(state, payload) {
            let filteredGisData = payload;

            if (typeof payload === 'function') {
                const newState = { ...state };
                filteredGisData = payload(newState.filteredGisData);
            }

            return { ...state, filteredGisData };
        },
        setCurveData(state, payload) {
            const curveData = { ...state.curveData };

            payload.forEach(item => {
                curveData[item.id] = {
                    ...item,
                    decimalLogarithm: false,
                    mirrorReflection: false,
                    median: false,
                    defaultXStart: item.xStart,
                    defaultXStop: item.xStop,
                    roof: 0,
                    bottom: 0,
                    centile: 10,
                };
            });

            return { ...state, curveData: curveData };
        },
        setCurvesByCode(state, payload) {
            const { id, data } = payload;
            return { ...state, curvesByCode: { ...state.curvesByCode, [id]: data } };
        },

        setCurveFillColor(state, payload) {
            return { ...state, curveFillColor: payload };
        },
        setMedian(state, payload) {
            const newData = { ...state.curveData };

            payload.ids.forEach(id => {
                const row = cloneDeep(newData[id]);
                row.median = payload.res;

                newData[id] = row;
            });
            return { ...state, curveData: newData };
        },
        setGraph(state, payload) {
            return { ...state, graph: payload };
        },
        setUpdatedMinValue(state, payload) {
            const updatedData = { ...state.curveData };

            payload.ids.forEach(id => {
                const row = cloneDeep(updatedData[id]);
                row.xStart = payload.res;

                updatedData[id] = row;
            });

            return { ...state, curveData: updatedData };
        },
        setUpdatedMaxValue(state, payload) {
            const updatedData = { ...state.curveData };

            payload.ids.forEach(id => {
                const row = cloneDeep(updatedData[id]);
                row.xStop = payload.res;

                updatedData[id] = row;
            });

            return { ...state, curveData: updatedData };
        },

        setUpdatedRoofValue(state, payload) {
            const updatedData = { ...state.curveData };

            payload.ids.forEach(id => {
                const row = cloneDeep(updatedData[id]);
                row.roof = payload.res;

                updatedData[id] = row;
            });

            return { ...state, curveData: updatedData };
        },
        setUpdatedBottomValue(state, payload) {
            const updatedData = { ...state.curveData };

            payload.ids.forEach(id => {
                const row = cloneDeep(updatedData[id]);
                row.bottom = payload.res;

                updatedData[id] = row;
            });

            return { ...state, curveData: updatedData };
        },
        setCentileValue(state, payload) {
            const updatedData = { ...state.curveData };

            payload.ids.forEach(id => {
                const row = cloneDeep(updatedData[id]);
                row.centile = payload.res;

                updatedData[id] = row;
            });

            return { ...state, curveData: updatedData };
        },
        switchPreparingGisData(state, payload) {
            return { ...state, preparingGisData: payload };
        },
        setGisCurveError(state, payload) {
            const { curve, title } = payload;

            return {
                ...state,
                gisCurveError: {
                    ...state.gisCurveError,
                    [curve]: `Данные по кривой ${title} не получены`,
                },
            };
        },
        setActiveWells(state, payload) {
            return { ...state, selectedWells: payload };
        },
        setActiveCurveDataKeys(state, payload) {
            return { ...state, activeCurveDataKeys: payload };
        },
        clearActiveCurveDataKeys(state) {
            return { ...state, activeCurveDataKeys: [] };
        },
        setOpenedGisItems(state, payload) {
            return { ...state, openedGisItems: payload };
        },
    },
    effects: dispatch => ({
        setSelectedWells(activeKey, rootState) {
            const data = cloneDeep(rootState.lists.data);
            const result = getItemByKeyRecursive(data, activeKey);

            dispatch.settings.setActiveWells([result]);
        },
        async loadColumns(_, rootState) {
            if (isEmpty(rootState.settings.columns)) {
                dispatch.settings.setLoading(true);
                let response = [];

                try {
                    response = await api.carottage.fetchColumns();

                    const WIDTH_TYPE = {
                        AUTO: 'AUTO',
                        PIXEL: 'PIXEL',
                        PERCENT: 'PERCENT',
                    };

                    response = response.map(column => {
                        column.keyTitle = column.keyTitle === 'geoObjects' ? 'geoObjects' : column.keyTitle;

                        column.widthType = WIDTH_TYPE.AUTO;
                        return column;
                    });

                    // добавляем колонку Пласт для ФГИ 530. По хорошему надо попросить бек присылать её.
                    response = [
                        ...response,
                        {
                            title: 'Пласт (ФГИ)',
                            key: response.length + 1,
                            isVisible: false,
                            width: 0,
                            keyTitle: 'geoObjectsFgi',
                            widthType: 'AUTO',
                        },
                    ];

                    dispatch.settings.setError(false);
                    dispatch.settings.setColumns(response);
                    dispatch.settings.setLoading(false);
                } catch (e) {
                    dispatch.settings.setError(true);
                    dispatch.settings.setLoading(false);
                }
                return response;
            } else {
                return rootState.settings.columns;
            }
        },
        async loadGisData(payload, rootState) {
            if (isEmpty(rootState.settings.gisData)) {
                dispatch.settings.setLoading(true);
                let response = [];

                try {
                    response = await api.carottage.fetchGisData();

                    response = response.map(item => {
                        return {
                            ...item,
                            children: item.children.map(child => {
                                return {
                                    ...child,
                                    visible: false,
                                    columnNumber: 1,
                                };
                            }),
                        };
                    });

                    dispatch.settings.setError(false);
                    dispatch.settings.setGisData(response);
                    dispatch.settings.setLoading(false);
                } catch (e) {
                    dispatch.settings.setError(true);
                    dispatch.settings.setLoading(false);
                }

                return response;
            } else {
                return rootState.settings.gisData;
            }
        },
        setSelectedGisDataRecordGlobal(result) {
            try {
                dispatch.settings.setSelectedRecordGlobal(result);
            } catch (error) {
                dispatch.settings.setError(true);
            }
        },
        setFilterGisData(callback) {
            try {
                dispatch.settings.setFilteredData(callback);
            } catch (error) {
                dispatch.settings.setError(true);
            }
        },
        async loadCurveData(data) {
            const json = JSON.stringify(data);
            dispatch.settings.setLoading(true);
            try {
                const response = await api.carottage.fetchCurveData(json);

                dispatch.settings.setError(false);
                dispatch.settings.setCurveData(response);
            } catch (e) {
                dispatch.settings.setError(true);
            }
            dispatch.settings.setLoading(false);
        },
        async getCurvesByCode(id, rootState) {
            dispatch.settings.setLoading(true);
            try {
                let codesResponse;

                if (rootState.settings.curvesByCode[id]) {
                    codesResponse = rootState.settings.curvesByCode[id];
                } else {
                    codesResponse = await api.carottage.fetchCurvesByCode([id]);
                    dispatch.settings.setCurvesByCode({ id, data: codesResponse });
                }

                return codesResponse;
            } catch (e) {
                console.log(e);
            }
            dispatch.settings.setLoading(false);
        },
        // получаем гисы, для типов которых есть кривые в исследованиях
        async getActiveGisTitles(ids, rootState) {
            const result = [];
            const gisData = cloneDeep(rootState.settings.gisData);

            for (const id of ids) {
                const codesResponse = await dispatch.settings.getCurvesByCode(id);

                const gisCodes = gisData
                    .map(data => {
                        return data.children.map(child => {
                            return [child.code, child.parentName];
                        });
                    })
                    .flat();

                const curves = gisCodes
                    .map(item => {
                        if (codesResponse[item[0]] !== undefined) {
                            return item[1];
                        }
                        return [];
                    })
                    .reduce((current, prev) => {
                        return current.concat(prev);
                    }, []);

                result.push(curves);
            }

            return [...new Set(result.flat())];
        },
        // ф-ция для фильтрации гисов
        async getActiveGisItems(data, rootState) {
            const { checkedIds, keys } = data;

            for (const key of keys) {
                const filteredTitles = await dispatch.settings.getActiveGisTitles(checkedIds);
                const gisData = getItemByKeyRecursive(rootState.lists.data, key).gisData;
                const filteredArray = gisData.filter(item => filteredTitles.includes(item.title));

                dispatch.settings.setFilterGisData(filteredArray);
            }
        },
        // получаем коды отрытых гисов
        async getVisibleGisCodes(data, rootState) {
            const { id, key } = data;

            const filteredTitles = await dispatch.settings.getActiveGisTitles(id);

            const gisData = getItemByKeyRecursive(rootState.lists.data, key).gisData;

            const filteredArray = gisData.filter(item => filteredTitles.includes(item.title));

            const openedGisItems = filteredArray
                .map(item => item.children)
                .flat()
                .filter(item => item.visible === true)
                .map(item => item.code);

            dispatch.settings.setOpenedGisItems(openedGisItems);
        },
        async loadDrawerData({ data, map }, rootState) {
            dispatch.settings.setDrawerLoading(true);
            const activeCurveKeys = [];
            try {
                for (const key of Object.keys(map)) {
                    const id = map[key];

                    const codesResponse = await dispatch.settings.getCurvesByCode(id); // коды всех кривых из исследований по активному id cкважины

                    dispatch.settings.setCurvesByCode({ key, codesResponse });

                    const codes = Object.keys(data).includes('children')
                        ? data.children.map(child => child.code)
                        : [data.code];

                    if (codes.length === 0) {
                        continue;
                    }

                    const curves = codes
                        .map(item => {
                            if (codesResponse[item] !== undefined) {
                                return codesResponse[item];
                            }
                            return [];
                        })
                        .reduce((current, prev) => {
                            return current?.concat(prev);
                        }, []);

                    const well = getItemByKeyRecursive(rootState.lists.data, key);
                    const keys = Object.keys(well.curveData).map(key => Number(key));

                    const missingCurves = curves.filter(item => !keys.includes(item));
                    activeCurveKeys.push(curves.filter(item => keys.includes(item)));

                    if (missingCurves.length !== 0) {
                        await dispatch.settings.addCurvesDataToItem({ ids: missingCurves, key });
                    }
                }

                dispatch.settings.setActiveCurveDataKeys(activeCurveKeys.flat());
                dispatch.settings.setError(false);
                dispatch.settings.setDrawerLoading(false);
            } catch (e) {
                dispatch.settings.setError(true);
                dispatch.settings.setDrawerLoading(false);
            }
        },
        setCurveFillColorGlobal(result) {
            try {
                dispatch.settings.setCurveFillColor(result);
            } catch (error) {
                dispatch.settings.setError(true);
            }
        },
        medianFunction({ ids, res }) {
            dispatch.settings.setMedian({ ids, res });
            dispatch.settings.setUpdateDataForTablets(true);
            dispatch.settings.switchPreparingGisData(true);
        },
        updateMinValue({ ids, res }) {
            dispatch.settings.setUpdatedMinValue({ ids, res });
            dispatch.settings.setUpdateDataForTablets(true);
            dispatch.settings.switchPreparingGisData(true);
        },
        updateMaxValue({ ids, res }) {
            dispatch.settings.setUpdatedMaxValue({ ids, res });
            dispatch.settings.setUpdateDataForTablets(true);
            dispatch.settings.switchPreparingGisData(true);
        },
        updateRoofValue({ ids, res }) {
            dispatch.settings.setUpdatedRoofValue({ ids, res });
            dispatch.settings.setUpdateDataForTablets(true);
            dispatch.settings.switchPreparingGisData(true);
        },
        updateBottomValue({ ids, res }) {
            dispatch.settings.setUpdatedBottomValue({ ids, res });
            dispatch.settings.setUpdateDataForTablets(true);
            dispatch.settings.switchPreparingGisData(true);
        },
        updateCentileValue({ ids, res }) {
            dispatch.settings.setCentileValue({ ids, res });
            dispatch.settings.setUpdateDataForTablets(true);
            dispatch.settings.switchPreparingGisData(true);
        },
        async saveListsDataChanges(payload) {
            for (const well of payload) {
                const newData = cloneDeep(await dispatch.settings.getDataFromListsState('data'));

                const updatedNewData = setItemByKeyRecursive(newData, well.key, well);
                dispatch.lists.setData(updatedNewData);
                await dispatch.lists.saveData(updatedNewData);
            }
        },
        async addCurveDataToItem(payload, rootState) {
            dispatch.settings.setCurveDataLoading(true);
            const { id, key } = payload;
            let data = await dispatch.settings.getDataFromState({ id, param: 'curveData' });
            if (!data) {
                await dispatch.settings.loadCurveData([id]);
                data = await dispatch.settings.getDataFromState({ id, param: 'curveData' });
            }

            const newData = cloneDeep(await dispatch.settings.getDataFromListsState('data'));
            const item = getItemByKeyRecursive(newData, key);

            if (item?.curveData === undefined || item?.curveData?.[id] === undefined) {
                const newItem = {
                    ...item,
                    curveData: {
                        ...item?.curveData,
                        [id]: { ...data },
                    },
                };

                const updatedNewData = setItemByKeyRecursive(newData, key, newItem);
                dispatch.lists.setData(updatedNewData);
                await dispatch.lists.saveData(updatedNewData);
            }
            dispatch.settings.setCurveDataLoading(false);
        },
        async addCurvesDataToItem(payload, rootState) {
            dispatch.settings.setCurveDataLoading(true);
            const { ids, key } = payload;
            await dispatch.settings.loadCurveData(ids);
            const data = await dispatch.settings.getAllDataFromState({ ids, param: 'curveData' });

            const newData = cloneDeep(await dispatch.settings.getDataFromListsState('data'));
            const item = getItemByKeyRecursive(newData, key);

            const newItem = {
                ...item,
                curveData: {
                    ...item?.curveData,
                    ...data,
                },
            };

            const updatedNewData = setItemByKeyRecursive(newData, key, newItem);

            dispatch.lists.setData(updatedNewData);
            await dispatch.lists.saveData(updatedNewData);
            dispatch.settings.setCurveDataLoading(false);
        },
        /*
            TODO: это какой то кошмар.
        */
        // устанавливает  открытый глаз в гисах для выбранных исследовааний, согласно типу по коду
        async setGisTypeVisible(payload, rootState) {
            const key = payload;
            const listData = await dispatch.settings.getDataFromListsState('data');
            const data = cloneDeep(getItemByKeyRecursive(listData, key));
            const gisData = cloneDeep(data.gisData);

            const checkedResearchCodes = [];
            cloneDeep(rootState.settingsResearch.research[key]).forEach(item => {
                item.children.forEach(child => {
                    child.children.forEach(lastChild => {
                        if (lastChild.isChecked) checkedResearchCodes.push(lastChild.code);
                    });
                });
            });

            const updatedGisData = gisData.map(gis => {
                gis.children = gis.children.map(child => {
                    if (checkedResearchCodes.includes(child.code)) {
                        child.visible = true;
                    }

                    return child;
                });

                return gis;
            });

            Object.assign(data, { gisData: updatedGisData });

            const newData = cloneDeep(await dispatch.settings.getDataFromListsState('data'));
            const updatedNewData = setItemByKeyRecursive(newData, key, data);
            dispatch.lists.setData(updatedNewData);
            await dispatch.lists.saveData(updatedNewData);
        },
        async loadGraph({ id, charts }) {
            dispatch.settings.setLoading(true);
            try {
                const chartsJson = JSON.stringify(charts);
                const response = await apiV2.carottage.fetchGraphData(id, chartsJson);

                dispatch.settings.setError(false);
                dispatch.settings.setGraph(response);
            } catch (e) {
                dispatch.settings.setError(true);
            }
            dispatch.settings.setLoading(false);
        },
        /**
         * Функция подготовки данных для планештов.
         * @param payload - на вход принимает массив ключей из lists.data.
         * @returns {Promise<void>}
         */
        async getNormalizedDataForTablet(payload, rootState) {
            const { tablets } = rootState;
            const { activeGroupName, activeTabletId } = tablets;

            if (payload === null) return;
            const carottage = {};
            try {
                // легаси
                // carottage = await dispatch.settings.prepareNormalizedDataForTablet(payload);
                dispatch.tablets.updateTablets({ carottage, activeGroupName, activeTabletId });
            } catch (error) {
                console.error(error);
            }
        },
        async prepareNormalizedDataForTablet(payload, rootState) {
            if (payload.length > 1) {
                const result = Promise.allSettled(
                    // возвращает массив targetTablet
                    payload.map(id =>
                        this.prepareNormalizedDataForTablet([id])
                            .then(res => ({
                                result: res,
                            }))
                            .catch(error => {
                                throw createError(error.message, '');
                            })
                    )
                );

                const reduced = {};
                await result.then(objects => {
                    objects.forEach(({ status, value }) => {
                        if (status === 'fulfilled') {
                            Object.assign(reduced, value.result);
                        }
                    });
                });

                return reduced;
            }

            const key = payload[0];

            if (!key) return undefined;
            const id = await dispatch.settings.getIdByKey(key);

            const researchListByKey = await this.getDataFromState({
                id: key,
                param: 'research',
                state: 'settingsResearch',
            });

            const checkedResearch = [];

            researchListByKey?.forEach(item => {
                const visibleChildren = [];
                item.children.forEach(c1 => {
                    c1.children.forEach(c2 => {
                        if (c2.isChecked) {
                            visibleChildren.push(c2);
                        }
                    });
                });
                if (visibleChildren.length > 0) checkedResearch.push(visibleChildren);
            });

            if (rootState.settings.gisData.length === 0) await dispatch.settings.loadGisData();

            const getWellData = async () => await dispatch.settings.getDataFromListsState('data');

            const gisData = getItemByKeyRecursive(await getWellData(), key).gisData;

            const allGisChildren = gisData.map(item => item.children).flat();

            await dispatch.settings.setGisTypeVisible(key);

            const gis = new Array(10);

            for (const research of checkedResearch) {
                const ids = research.map(curve => curve.curve);
                const keys = Object.keys(rootState.settings.curveData);
                if (!ids.every(id => keys.includes(id))) {
                    await dispatch.settings.loadCurveData(ids);
                }

                for (const curve of research) {
                    const data = await this.getDataFromState({ id: curve.curve, param: 'curveData' });
                    await dispatch.settings.addCurveDataToItem({ id: curve.curve, key });

                    if (!data || data.length === 0) {
                        this.setGisCurveError(curve);
                        continue;
                    }

                    const { x, y, xStart, xStop, decimalLogarithm, mirrorReflection, median, xStep } = data;

                    const currentGis = allGisChildren?.filter(data => data?.code === curve?.code)[0];

                    if (currentGis) {
                        const newCurve = {
                            ...curve,
                            x: x,
                            y: y,
                            xStart: xStart,
                            xStep: xStep,
                            xStop: xStop,
                            decimalLogarithm: decimalLogarithm,
                            mirrorReflection: mirrorReflection,
                            median: median,
                            color: currentGis.color,
                            lineWidth: currentGis.lineWidth,
                            lineType: currentGis.lineType,
                        };

                        const columnIdx = currentGis.columnNumber - 1;
                        const dt = gis[columnIdx];

                        if (!dt) {
                            gis.splice(columnIdx, 1, [newCurve]);
                        } else {
                            gis.splice(columnIdx, 1, [...dt, newCurve]);
                        }
                    }
                }
            }

            const targetTablet = {
                [id]: {
                    carottage: gis.filter(it => it),
                },
            };

            return targetTablet;
        },
        getDataFromState(payload, rootState) {
            const { id = undefined, param, state = 'settings' } = payload;
            if (id === undefined) return rootState[state][param];
            else return rootState[state][param][id];
        },
        async getAllDataFromState(payload, rootState) {
            const { ids, param } = payload;
            const result = {};

            for (const id of ids) {
                Object.assign(result, { [id]: rootState.settings[param][id] });
            }

            return result;
        },
        getDataFromListsState(payload, rootState) {
            return rootState.lists[payload];
        },
        updateDataForTablets(payload) {
            dispatch.settings.setUpdateDataForTablets(payload);
            dispatch.settings.switchPreparingGisData(true);
        },
        getIdByKey(key, rootState) {
            if (!key) return undefined;
            const { data } = rootState.lists;
            return getItemByKeyRecursive(data, key).id;
        },
    }),
    selectors: (_, createSelector) => ({
        gisDataToTable() {
            return createSelector(
                rootState => rootState.settings.gisData || [],
                gisData => {
                    const flatData = gisData.reduce((acc, item) => {
                        const children = item?.children || [];
                        return [...acc, ...children];
                    }, []);

                    return flatData.map((row, idx) => ({
                        index: idx + 1,
                        ...row,
                    }));
                }
            );
        },
    }),
};

export default settingsModel;

/**
 * :TODO эксперимент
 */
function createError(msg, info = {}) {
    const error = new Error();
    error.message = msg;
    error.info = info;
    return error;
}
